import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrganizationShifts } from './interface';
import { ApiService } from './../../Services/api.service';
import { StorageService } from './../../Services/storage.service';


export class Store<T>{
    private state$: BehaviorSubject<OrganizationShifts[]>;
    protected constructor(initialState: OrganizationShifts[] = []) {
        this.state$ = new BehaviorSubject(initialState);
    }
    getValue(): OrganizationShifts[] {
        return this.state$.getValue();
    }
    getState(): Observable<OrganizationShifts[]> {

        return this.state$.asObservable();
    }
    setState(item: OrganizationShifts[]): void {
        this.state$.next(item);
    }
}


@Injectable()
export class OrgShiftStateManagement extends Store<OrganizationShifts>{
    constructor(
        private api: ApiService,
        private storage: StorageService
    ) {
        super();
    }

    update(newData: any): void {
        try {
            this.setState(newData);
            // const data = this.getValue();
        } catch (error) {
            console.log('Error ', error);
        }
    }

    get(): OrganizationShifts[] {
        let shifts: any = this.getValue();
        return shifts;
    }
    listen(): Observable<OrganizationShifts[]> {
        return this.getState();
    }
    async fetchShiftList() {
        if (this.get().length <= 0) {
            let orgInfo = this.storage.get('userInfo');
            let obj = { orgID: orgInfo['orgID'] };
            let shiftData = [], ping = 1, i = 0;
            while (ping) {
                obj['page'] = i + 1;
                i++;
                let res = await this.api.ListShift(obj).catch((e) => { console.log("Get Shift data"); });
                if (res && res['status'] == 'success') {
                    if (res['data'].length <= 0) ping = 0;
                    else {
                        shiftData = [...shiftData, ...res['data']];
                        this.setState(shiftData); 
                    }
                }else ping = 0;
            } 
        }
    }
}